module.exports = __webpack_public_path__ + "img/project7_8.png.080bcc60.webp";